<template>
  <div class="protocol-item-base clear">
    <div class="base-info">
      <el-form :model="form" :rules="rules" ref="form" class="form-section">
        <el-form-item :label="$t('dms_protocol_item_base.xie_yi_lei_xing')" prop="protocolType">
          <custom-select code="protocol_type" v-model="form.protocolType" :disabled="true" width="100%"></custom-select>
        </el-form-item>
        <el-form-item :label="$t('dms_protocol_item_base.xie_yi_lei_bie')" prop="protocolClass">
          <custom-select code="iot_protocol_class" v-model="form.protocolClass" width="100%" @getList="protocolClassListInit" @change="onProtocolClassChange"></custom-select>
        </el-form-item>
        <el-form-item :label="$t('dms_protocol_item_base.xie_yi_bian_ma')" prop="protocolCode">
          <el-input v-model="form.protocolCode" :disabled="!protocolCodeVisible"></el-input>
        </el-form-item>
        <el-form-item :label="$t('dms_protocol_item_base.xie_yi_ming_cheng')" prop="protocolName">
          <el-input v-model="form.protocolName" :disabled="!protocolNameVisible"></el-input>
        </el-form-item>
        <el-form-item :label="$t('dms_protocol_item_base.shu_ju_ge_shi')" prop="dataFormat">
          <custom-select code="iot_protocol_data_format" v-model="form.dataFormat" width="100%"></custom-select>
        </el-form-item>
        <el-form-item :label="$t('dms_protocol_item_base.xie_yi_miao_shu')" prop="protocolDesc">
          <el-input type="textarea" v-model="form.protocolDesc"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="footer">
      <el-button type="primary" @click="saveHandler">{{ $t('Common.com_save') }}</el-button>
      <el-button @click="onCancel">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="primary" @click="onStep">{{ $t('dms_protocol_item_base.xybxyjg') }}</el-button>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';

export default {
  name: 'protocolItemBase',
  components: {},
  props: {
    info: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      form: {
        // 协议编码（标准协议不可更改） protocolCode
        protocolCode: '',
        // 协议名称（标准协议不可更改） protocolName
        protocolName: '',
        // 协议类别 protocolClass iot_protocol_class
        protocolClass: '',
        // 协议类型 protocolType iot_protocol_type
        protocolType: '',
        // 数据格式 dataFormat  iot_protocol_data_format
        dataFormat: '',
        // 协议描述 protocolDesc
        protocolDesc: '',
      },
      protocolClassList: [],
    };
  },
  computed: {
    rules() {
      return {
        protocolCode: {
          required: true,
          message: this.$t('Common.com_required')
        },
        protocolName: {
          required: true,
          message: this.$t('Common.com_required')
        },
        protocolClass: {
          required: true,
          message: this.$t('Common.com_required')
        },
        protocolType: {
          required: true,
          message: this.$t('Common.com_required')
        },
        dataFormat: {
          required: true,
          message: this.$t('Common.com_required')
        },
        // protocolDesc: {
        //   required: true,
        //   message: '必填项'
        // },
      };
    },
    protocolCodeVisible() {
      return this.form.protocolType !== '1';
    },
    protocolNameVisible() {
      return this.form.protocolType !== '1';
    },
  },
  watch: {
    info() {
      this.init();
    },
  },
  filters: {},
  directives: {},
  methods: {
    protocolClassListInit(list) {
      this.protocolClassList = list;
    },
    onProtocolClassChange() {
      // 新增时编码与名称根据选中的协议类别显示
      if (this.form.protocolType === '1') {
        const protocolClass = this.form.protocolClass;
        const item = this.protocolClassList.find(obj => obj.value === protocolClass);
        this.form.protocolName = item.name;
        this.form.protocolCode = item.code;
      }
    },
    // 取消
    onCancel: function () {
      this.$emit('cancel');
    },
    onConfirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.info.protocolCode) {
            this.save();
          } else {
            this.create();
          }
        }
      });
    },
    save() {
      return this.$postJSON(apis.ProtocolSave, this.getEditReqData());
    },
    create() {
      return this.$postJSON(apis.ProtocolSave, this.getCreateReqData());
    },
    // 下一步
    async onStep() {
      this.$refs.form.validate(async (val) => {
        if (val) {
          if (this.info.protocolCode) {
            await this.save();
            this.$emit('step', {
              name: 'info',
            });
          } else {
            const data = await this.create();
            this.$emit('step', {
              name: 'info',
              info: data.data,
            });
          }
        }
      });
    },
    async saveHandler() {
      this.$refs.form.validate(async (val) => {
        if (val) {
          if (this.info.protocolCode) {
            await this.save();
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
          } else {
            const data = await this.create();
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
            this.$emit('update', data.data);
          }
        }
      });
    },
    getCreateReqData() {
      return {
        ...this.form,
      };
    },
    getEditReqData() {
      const ret = {
        ...this.form,
      };
      if (this.info.protocolId) {
        ret.protocolId = this.info.protocolId;
      }
      return ret;
    },
    init() {
      this.$setFormatData(this.form, this.info);
    },
  },
  created() {},
  mounted() {
    this.init();
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';

.protocol-item-base {
  padding-bottom: 60px;
  overflow: hidden;

  .base-info {
    float: left;
    width: 420px;

    .form-section {
      .el-form-item__label {
        color: #495057 !important;
        font-weight: bold;
        width: 100%;
        text-align: left;
      }

      .el-textarea__inner {
        height: 63px !important;
      }
    }

    .copy {
      float: right;
    }
  }

  .line {
    position: absolute;
    width: 1px;
    top: 24px;
    bottom: 84px;
    left: 689px;
    margin: auto;
    background: #f2f3fb;
  }

  .product-r {
    float: left;
    margin-left: 49px;
    width: 355px;

    .title {
      line-height: 28px;
      color: #495057;
      font-size: 12px;
      font-weight: bold;
    }
  }
}
</style>
